import {
  Dialog,
  Button,
  Typography,
  Box,
  TextField,
  Snackbar,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import React, { useEffect, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ja } from "date-fns/locale";
import { ForgotPasswordDialogStyle as styles } from "./ForgotPasswordDialogStyle";
import { useApiPasswordReset } from "../hooks/api/useApiPasswordReset";
import { RequestPasswordReset } from "../services/OpenAPI";

type Props = {
  open: boolean;
  onClose: () => void;
};

const ForgotPasswordDialog: React.FC<Props> = ({ open, onClose }) => {
  const { submit } = useApiPasswordReset();
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState<"success" | "error">(
    "success"
  );
  const handleCloseToast = () => setToastOpen(false);

  const [mailAddress, setMailAddress] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!mailAddress) {
      setToastMessage("メールアドレスを入力してください。");
      setToastSeverity("error");
      setToastOpen(true);
      return;
    }

    setIsSubmitting(true);
    const req: RequestPasswordReset = {
      mail: mailAddress,
    };
    const result = await submit(req);
    if (result) {
      setToastMessage(
        "パスワード再設定用のリンクをメールでお送りしました。メールをご確認ください。"
      );
      setToastSeverity("success");
      setToastOpen(true);
      setTimeout(() => {
        setIsSubmitting(false);
        setMailAddress("");
        setToastOpen(false);
        onClose();
      }, 2000);
    } else {
      setToastMessage("パスワードリセットに失敗しました。");
      setToastSeverity("error");
      setToastOpen(true);
      setTimeout(() => {
        setIsSubmitting(false);
        setMailAddress("");
        setToastOpen(false);
        onClose();
      }, 2000);
    }
  };

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
        <Dialog
          open={open}
          onClose={(event, reason) => {
            if (reason !== "backdropClick") onClose();
          }}
          disableEnforceFocus
          maxWidth={false}
          fullWidth={false}
          PaperProps={{
            sx: {
              display: "flex",
              width: "700px",
              height: "250px",
              maxWidth: "none",
              maxHeight: "none",
              overflowY: "auto",
            },
          }}
        >
          <Box sx={styles.header}>
            <Typography sx={styles.headerText}>パスワード再設定登録</Typography>
            <Button
              onClick={() => {
                onClose();
              }}
              sx={styles.closeButton}
            >
              ×
            </Button>
          </Box>

          <Box sx={styles.formArea}>
            <TextField
              label="メールアドレス"
              value={mailAddress}
              onChange={(e) => setMailAddress(e.target.value)}
              sx={{ mb: 3, width: "450px" }}
            />
          </Box>
          <Box display="flex" justifyContent="center">
            <Button
              variant="contained"
              sx={{ width: "150px" }}
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              メール送信
            </Button>
          </Box>
          <Snackbar
            open={toastOpen}
            autoHideDuration={4000}
            onClose={handleCloseToast}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <MuiAlert
              onClose={handleCloseToast}
              severity={toastSeverity}
              sx={{ width: "100%" }}
              elevation={6}
              variant="filled"
            >
              {toastMessage}
            </MuiAlert>
          </Snackbar>
        </Dialog>
      </LocalizationProvider>
    </>
  );
};

export default ForgotPasswordDialog;
